import { InsuranceCoverageMonitor } from "./types";
import { monitorService } from "./service";

export const getInsuranceCoverageMonitor = async (
  monitorId: string
): Promise<InsuranceCoverageMonitor> => {
  const { data } = await monitorService.get<InsuranceCoverageMonitor>(
    `/${monitorId}`
  );

  return data;
};
